<template>
  <div class="card shadow-sm">
    <div class="p-4 pb-0 card-header">
      <h6 class="mb-0">재료</h6>
    </div>
    <div class="card-body pt-4 p-3">
      <ul class="list-group">
        <li
          v-for="rawMaterial in rawMaterialList"
          :key="rawMaterial.id"
          class="list-group-item border-0 d-flex p-4 mb-2 bg-gray-100 border-radius-lg card-hover position-relative align-items-center"
        >
          <soft-icon
            :icon="rawMaterial.iconName"
            shadow="sm"
            style="font-size: 24px;"
          />
          <div class="d-flex flex-column ps-3">
            <h6 class="mb-1 text-sm">{{ rawMaterial.name }}</h6>
            <p class="mb-1 text-sm">{{ rawMaterial.sgtin }}</p>
          </div>
          <span
            class="mb-0 btn btn-link pe-3 ps-0 ms-auto"
            style="cursor: default; white-space: nowrap;"
          >
            {{
              rawMaterial.ecoYn === 'Y' && rawMaterial.hazYn === 'Y'
                ? '친환경 / 유해성'
                : rawMaterial.ecoYn === 'Y'
                ? '친환경'
                : rawMaterial.hazYn === 'Y'
                ? '유해성'
                : ''
            }}
          </span>
          <div
            class="hover-overlay d-flex justify-content-center align-items-center"
            @click="$emit('click-material', rawMaterial.id, rawMaterial.sgtin)"
          >
            이력
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SoftIcon from "@/components/SoftIcon.vue";
export default {
  name: 'RawMaterialCard',
  props: {
    rawMaterialList: {
      type: Array,
      required: true,
    },
  },
  components: {
    SoftIcon,
  },
}
</script>
<style scoped>
.card-hover {
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
  background-color: #f8f9fa; /* bg-gray-100 느낌 */
  transition: background-color 0.3s ease;
}

.card-hover:hover {
  background-color: #e9ecef !important;
  cursor: pointer;
}
.hover-overlay {
  position: absolute;
  top: 0;
  right: -100px;
  width: 100px;
  height: 100%;
  background-color: #2563eb;
  color: #fff;
  font-weight: bold;
  font-size: 0.85rem;
  transition: font-size 0.3s ease, right 0.3s ease;
  z-index: 10;
  user-select: none;
}

.card-hover:hover .hover-overlay {
  right: 0;
}

.hover-overlay:hover {
  font-size: 1rem;
  cursor: pointer;
}
</style>